<template>
  <div class="api-key-list">
    <div class="headings">
      <div class="main-headings">
        <div class="heading heading-key" @click="onToggleSort('name')">
          <h3>{{ $t("api-list.top-key") }}</h3>
          <div v-if="sortKey === 'name'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
        <div class="heading heading-scopes" @click="onToggleSort('scopes')">
          <h3>{{ $t("api-list.top-scopes") }}</h3>
          <div v-if="sortKey === 'scopes'">
            <span v-show="descending">
              <i class="fa-light fa-caret-down"></i>
            </span>
            <span v-show="!descending">
              <i class="fa-light fa-caret-up"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="heading heading-actions"></div>
    </div>

    <ul class="list-wrapper custom-scrollbar-light" v-if="apiKeys.length">
      <li v-for="apiKey in sortedKeys" :key="apiKey.id" class="api" :id="apiKey.name">
        <div class="content-wrapper">
          <div class="main-info">
            <p class="name">
              {{ apiKey.name }}

              <button
                class="btn btn-xs rename"
                @click="onRename(apiKey)"
                :tooltip="$t('api-list.rename')"
                tooltip-placement="bottom"
              >
                <span>
                  <i class="fa-light fa-pen"></i>
                </span>
              </button>
            </p>
            <p class="text-small text-muted">
              <span>
                {{ apiKey.key }}
              </span>
              <span
                v-show="apiKey.newApiKey"
                class="copy-to-clipboard"
                :tooltip="tooltipCopyText"
                tooltip-placement="right"
                @mouseout="tooltipCopyText = $t('copy-to-clipboard')"
                @click="copyToClipboard(apiKey.key)"
              >
                <i class="fa-light fa-clipboard"></i>
              </span>
            </p>
          </div>

          <div class="scopes-info text-muted text-small">
            <p>{{ scopeInfo(apiKey.scopes) }}</p>
          </div>
        </div>

        <div class="actions">
          <button class="btn-rounded-tertiary" @click="onEdit(apiKey)">
            <span>
              <i class="fa-light fa-pen"></i>
            </span>
            {{ $t("api-list.scopes") }}
          </button>

          <button class="btn" @click="onDelete(apiKey)">
            <span>
              <i class="fa-light fa-trash"></i>
            </span>
            <!-- {{ $t("api-list.delete") }} -->
          </button>
        </div>
      </li>
    </ul>
    <div v-else class="no-content text-muted">
      No api keys yet
    </div>

    <div class="list-footer">
      <span class="text-small text-muted">{{ $t("api-key.api-key-count") }}: {{ apiKeys.length }}</span>
    </div>
  </div>
</template>

<script>
import appHelper from "@/assets/js/appHelper.js";
import EditScopes from "@/components/modals/EditScopes";
import RenameModal from "@/components/modals/RenameModal";
import orderBy from "lodash/orderBy";
export default {
  data() {
    return {
      sortKey: "name",
      descending: false,
      scopeUniqueName: [],
      succes: false,
      tooltipCopyText: this.$t("copy-to-clipboard")
    };
  },

  props: {
    apiKeys: Array,
    scopes: Array
  },
  methods: {
    scopeInfo(scopes) {
      if (scopes.length === 0) return this.$t("disabled");
      else if (scopes.length === 1 && scopes[0].uniqueName === "template_generate") return this.$t("api-list.standard");
      else return this.$t("api-list.userdefined");
    },
    copyToClipboard(string) {
      appHelper.copyToClipboard(string);
      this.tooltipCopyText = this.$t("copied");
    },
    onToggleSort(sortKey) {
      this.descending = this.sortKey == sortKey ? !this.descending : false;
      this.sortKey = sortKey;
    },
    onRename(apiKey) {
      this.$modal.show(
        RenameModal,
        {
          title: this.$t("api-list.rename-modal"),
          inputName: this.$t("rename-template-modal.new-name"),
          primaryButton: this.$t("rename-template-modal.save"),
          existingName: apiKey.name,
          onSave: (newName) => {
            apiKey.name = newName;
            this.$store.dispatch("renameApi", apiKey).then(() => {
              this.showNotice();
            });
          }
        },
        { width: 310, height: "auto" }
      );
    },
    onEdit(apiKey) {
      this.scopeUniqueName = [];
      apiKey.scopes.map((scope) => {
        const scopeName = scope.uniqueName;
        this.scopeUniqueName.push(scopeName);
      });
      this.$modal.show(
        EditScopes,
        {
          scopes: this.$store.state.scopes.map((s) => {
            if (s.uniqueName === "template_generate") {
              return { ...s, prettyName: s.prettyName + " (default)" };
            } else return s;
          }),
          currentScopes: this.scopeUniqueName,
          id: apiKey.id,
          name: apiKey.name,
          onSave: (checkedNames) => {
            this.$store.dispatch("editScopes", checkedNames).then(() => {
              this.showNotice();
            });
          }
        },
        { width: 600, height: "auto", adaptive: true }
      );
    },
    onDelete(apiKey) {
      this.$store.dispatch("deleteApi", apiKey).then(() => {
        this.showNotice();
      });
    },
    showNotice() {
      this.succes = true;
      setTimeout(
        function() {
          this.succes = !this.succes;
        }.bind(this),
        3500
      );
    }
  },
  computed: {
    sortedKeys() {
      return orderBy(this.apiKeys || [], (apiKey) => apiKey[this.sortKey].toString().toLowerCase(), [
        this.descending ? "desc" : "asc"
      ]);
    }
  }
};
</script>

<style lang="less">
.api-key-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: clamp(100px, 100%, 80vh);
  overflow: hidden;
  background: #fff;
  border-radius: var(--standard-border-radius);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);

  .headings {
    display: none;
    h3 {
      font-weight: 700;
    }
  }
  .list-wrapper, .no-content {
    overflow: auto;
    max-height: calc(80vh - 110px);
    min-height: 100px;
  }
  .no-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ul {
    padding: 12px 0 0 0;
    list-style-type: none;
    li {
      margin: 8px 20px;
      border-bottom: 1px solid var(--charcoal-20);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;

      .content-wrapper {
        .main-info {
          flex-grow: 1;
          .name {
            display: flex;
            margin-bottom: 8px;
            align-items: center;
          }
        }
      }
      .actions {
       
        display: flex;
        justify-content: flex-end;
        align-items: center;

        button{
          color: var(--charcoal-50);
        }
      }

      .copy-to-clipboard{
        color: var(--charcoal);
        margin-left: 8px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .list-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 18px 20px;
    border-top: 1px solid var(--charcoal-20);
    p {
      margin-bottom: 0;
    }
  }
}

@media screen and (min-width: 768px) {
  .api-key-list {
    max-width: 800px;
    display: flex;
    flex-direction: column;
    .headings {
      display: flex;
      flex-grow: 1;
      border-bottom: 1px solid var(--charcoal-20);
      padding: 14px 20px;
    }
    .main-headings {
      flex-grow: 1;
      display: grid;
      grid-template-columns: minmax(auto, 75%) auto;

      .heading {
        cursor: pointer;
        display: flex;
        gap: 8px;
        align-items: center;
        h3 {
          color: var(--charcoal-75);
          margin-bottom: 0;
        }
      }

      .heading-key {
        flex-grow: 1;
      }
      .heading-scopes {
        width: 120px;
        display: flex;
        justify-content: flex-start;
      }
    }
    .heading-actions {
      width: 170px;
      display: flex;
      justify-content: flex-end;
    }

    ul {
      li {
        .content-wrapper {
          display: grid;
          grid-template-columns: minmax(auto, 75%) auto;
          flex-grow: 1;
          align-items: center;

          .scopes-info {
            width: 120px;
            display: flex;
            justify-content: flex-start;
          }
        }
        .actions{
          width: 170px;
        }
        .rename {
          opacity: 0;
          font-size: 12px;
          display: flex;
          &:focus {
            opacity: 1;
          }
        }

        &:hover {
          .rename {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
